import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { ConfirmationDialogComponent, DialogService, ConfirmationDialogArgs } from 'shared/ui-common';

export const isMobileGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const dialogService = inject(DialogService);
  const router = inject(Router);

  if (!isMobile(navigator.userAgent)) {
    return of(true);
  }

  const args: ConfirmationDialogArgs = {
    message: 'EditorNotOptimisedForMobileViewMessage',
    cancelButtonCaption: 'Continue',
    confirmButtonCaption: 'BackToOverview',
  };
  const mobileWarningDialog = dialogService.open(ConfirmationDialogComponent, {
    icon: 'triangle-alert',
    title: 'EditorNotOptimisedForMobileView',
    data: args,
    disableClose: false,
  });

  return mobileWarningDialog.afterClosed().pipe(map((result) => (!result ? true : router.parseUrl('/manage'))));
};

const isMobile = (userAgentString: string) => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(userAgentString);
};
